module.exports = __webpack_public_path__ + "img/bg_map_03.579870ca.jpg";